import { render, staticRenderFns } from "./SidebarProfile.vue?vue&type=template&id=a3977ae8&scoped=true"
import script from "./SidebarProfile.vue?vue&type=script&lang=js"
export * from "./SidebarProfile.vue?vue&type=script&lang=js"
import style0 from "./SidebarProfile.vue?vue&type=style&index=0&id=a3977ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3977ae8",
  null
  
)

export default component.exports